<template>
    <div class="form-dynamic-wrapper mb-2" style="max-width:100% !important">
        <b-row class="pr-5">
            <b-col md="2">
                <b-form-group>
                    <label>Name</label>
                    <b-form-input v-model="spesifikasi.name" name="spesifikasiName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-form-group>
                    <label class="radio-label">
                        <b-form-radio v-model="spesifikasi.detailInfo" value="persen">Persen</b-form-radio>
                    </label>
                    <b-input-group append="%">
                        <b-form-input v-model="spesifikasi.nominalPersen" :id="`persenDesc-${spesifikasi.index}`" name="spesifikasiNominalPersen" step="0.01" type="number" @blur="roundPersen" :disabled="spesifikasi.detailInfo == 'nominal'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-popover :target="`persenDesc-${spesifikasi.index}`" title="Catatan" triggers="focus">
                    <ul class="tooltip-content-wrapper list-popover-wrapper">
                        <li class="mb-2">
                            <span class="small-muted-persen">100%</span>  -> harga dasar (tidak ada penambahan maupun pengurangan)
                        </li>
                        <li class="mb-2">
                            <span class="small-muted-persen">110%</span>  -> Tambahan 10% dari harga barang
                        </li>
                        <li class="mb-0">
                            <span class="small-muted-persen">80%</span>  -> Potongan 20% dari harga barang
                        </li>
                    </ul>
                </b-popover>
            </b-col>
            <b-col md="2">
                <b-form-group class="radio-label">
                    <label>
                        <b-form-radio v-model="spesifikasi.detailInfo" value="nominal">Nominal</b-form-radio>
                    </label>
                    <b-input-group prepend="Rp.">
                        <b-form-input v-model="spesifikasi.nominalAngka" name="spesifikasiNominalAngka" :disabled="spesifikasi.detailInfo == 'persen'" required></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="10" md="2" >
                <label for="file">File PDF</label>
                <FormulateForm v-model="pdf">
                    <FormulateInput v-if=" spesifikasi.url != null && spesifikasi.url.length != 0"
                    id="urlPDF"
                    name="urlPDF"
                    ref="urlPDF"
                    type="file"
                    :value="spesifikasi.url"
                    help="Format Harus PDF"
                    accept=".pdf"
                    validation="mime:application/pdf"
                    multiple
                    />
                    <FormulateInput v-else
                    type="file"
                    name="file"
                    help="Format Harus PDF"
                    validation="mime:application/pdf"
                    accept=".pdf"
                    fileRemove
                    multiple
                    />
                </FormulateForm>
                    <!-- <b-button variant="pgiBtn" class="mb-2" @click="addPdf" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Add PDF</b-button> -->
                    
            </b-col>
            <b-col cols="2" class="mt-4">
                <div v-if="pdf != null "> 
                    <div v-if="pdf.urlPDF != undefined || pdf.urlPDF != null ">
                        <div v-for="(file, index) in pdf.urlPDF.files" :key="index">
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 

                    <div v-if="pdf.file != undefined || pdf.file != null ">
                        <div v-for="(file, index) in pdf.file.files" :key="index">
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreviewPDF( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 
                </div>
                
            </b-col>    
            <b-col md="2" style="margin-top: 30px" :hidden="isInputJenis == false && isEditJenis == false" >
                    <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung" name="fotoPendukungAddBtn"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                    <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal 6 Foto</div>
            </b-col>
        </b-row>      
        
                <div v-for="item in fotoPendukung" :key="item.index">
                    <FotoPendukungJenisBarang :hidden="item.hidden == true || isInputJenis == false && isEditJenis == false "
                                   :idSpesifikasi="spesifikasi.id"
                                    :fotoPendukung="item"
                                    :isEditJenis="isEditJenis"
                                    :length="fotoPendukung.length" 
                                    :minLength="minLengthFotoPendukung"
                                    @remove="removeFoto"
                                    @showModalCam="openModalCam" 
                                    @showModalPreview="openModalPreview"
                                    required 
                                />
                
            <!-- <ModalPreview :modalId='item.name != null ?"modal-preview-gadai"+item.name :"modal-preview-gadai"+item.index' :fotoPreview='item.name != null ?$baseFilePath + item.name :item.activeFotoPendukungBase64 ' /> -->
                </div>
           
   
       
        <div class="form-dynamic-deleteWrapper">
            <b-button variant="dynamicDeleteBtn" name="deleteSpesifikasi" @click="$emit('remove', spesifikasi.index)"><i class="fa fa-times"></i></b-button>
            <b-button v-if="$listeners.nonAktif" variant="dynamicDeleteBtn mt-2" name="nonAktifSpesifikasi" :disabled="spesifikasi.isNewSpek == true" @click="$emit('nonAktif', spesifikasi.index)"><i class="fa fa-minus"></i></b-button>
        </div>

    </div>
    
</template>

<script>

import FotoPendukungJenisBarang from '../webcam/FotoPendukungJenisBarang.vue';
import ModalPreview from '../webcam/ModalPreview.vue';
import ModalWebCam from '../webcam/ModalWebCam'

import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)
export default {
   
    name: "spesifikasi",
    components: {
        FotoPendukungJenisBarang,
        ModalWebCam,
        ModalPreview,
        VueFormulate
    },
    props: {
        spesifikasi: { type: Object, required: true },
        length: { type: Number, required: true },
        isInputJenis : { type : Boolean , default: false},
        isEditJenis : { type : Boolean , default: false},
        fotoPendukung : { type : Array},
        idSpesifikasi:{ type : Number },
        filePDF : { type : Array},
    },
    
    data() {
        return {
    
            indexFotoPendukung: (this.fotoPendukung != null) ? this.fotoPendukung.length :null ,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreviewIndex: null,
            minLengthFotoPendukung: 0,
            activeFotoPreview: "",
            isCreate: true,

            confirmDelId:null,
            confirmDelIndex:null,

            pdf: null,
            //activePdfPreview: null,

            pdfRecords : [],
            pdfNewVal:[],

        }
    },
    
    
    methods: {
        roundPersen() {
            var x = Number(this.spesifikasi.nominalPersen).toFixed(2);
            this.spesifikasi.nominalPersen = x;
        },

       
        openModalCam(id,index){
          
            //this.activeFotoPendukungIndex = index
            this.$emit('showModalCam' , id , index)
            //this.$bvModal.show("webcam-input-elek")
        },
        
        openModalPreview(idSpek,idFoto,index,name){
            this.$emit('showModalPreview',idSpek,idFoto,index,name)
            //this.$bvModal.show("modal-preview-gadai"+index)
        },

        async setResult(result){
            //letakin ke null masing2
            var newResult = await this.$helper.resizeImage(result)
            let idx = this.fotoPendukung.findIndex(item => item.index == this.activeFotoPendukungIndex);
            this.fotoPendukung[idx].fotoBarangPendukungBase64 = newResult
            this.fotoPendukung[idx].activeFotoPendukungBase64 = newResult
            this.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera"
            this.fotoPendukung[idx].checkFotoBarangPendukung = true
        },

        removeFoto(id , index ,idSpesifikasi){
            this.$emit('removeFoto' , id , index, idSpesifikasi)
        },
        
        //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

        // addPdf() {
        //     this.filePDF = {
        //         name : "filePDF",
        //         file: null ,
        //         base64: null
        //     }
        // },

        addFotoPendukung() {
            
            if(this.fotoPendukung.length < 6){
                this.fotoPendukung.push({ 
                    id: this.idSpesifikasi, 
                    index: this.indexFotoPendukung,
                    checkFotoBarangPendukung: false,
                    fotoBarangPendukungPlaceholder: 'Choose a file',
                    fotoBarangPendukung: null,
                    fotoBarangPendukungBase64: null,
                    activeFotoPendukungBase64: null,
                    isNew: true,
                })
                this.indexFotoPendukung++
            }else{
                this.fotoPendukungError = true;
            }
           
        },

        removeFotoPendukung(id , index) {
           
           if(Number(index)){
            this.fotoPendukung = this.fotoPendukung.filter(item => item.index != index)
           }
           else if( index == 0){
            this.fotoPendukung = this.fotoPendukung.filter(item => item.index != index)
           }
           else{
           // let del = this.fotoPendukung.filter(item => item.name == index)
            for(var x of this.fotoPendukung){
                if(x.id == id ){
                    x.hidden = true
                }
            }
           }
            this.fotoPendukungError = false;
    
            this.$emit('removeFoto' , this.fotoPendukung , this.idSpesifikasi)
            this.$bvModal.hide("modal-hapus"+index)
        },

        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },
        openModalPreviewPDF(pdf){
            if(pdf.size != null){  
                    this.toBase64(pdf).then(async base64 => {   
                    this.$emit('openModalPreviewPDFSpekKel' ,base64)
                 })
                
            }

            this.$emit('openModalPreviewPDFSpekKel' ,pdf)
                
        },
    },

    watch: {
        "filePDF":function (newValue){
            this.pdfRecords = newValue 

            if(this.pdf.urlPDF != null){
                this.pdf.urlPDF.files = newValue
            }
        },
        "spesifikasi.nominalAngka": function (newValue) {
            let cleanValue = this.$helper.changeToValue(newValue);
            const result = cleanValue.replace(/(?!^-)[^0-9]/g, "")
                .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            this.$nextTick(() => this.spesifikasi.nominalAngka = result);
        },
     
        "pdf.urlPDF.files" : function(newValue){
            //Hapus SE
            if(this.pdfRecords.length > newValue.length){
                this.pdf.urlPDF.files = this.pdfRecords
                this.pdfNewVal = newValue

                this.$emit('removeSESpek' , this.idSpesifikasi ,this.pdfRecords,newValue)
                
            }

            else if (newValue.length == this.pdfRecords.length){
            
            }
            //Tambah SE
            else{
                let Pdfbase64 = []
                if(newValue.length != 0){
                    for(var file of newValue){
                        Pdfbase64.push(file)
                    }
                this.pdfRecords = Pdfbase64
                this.$emit('changeSESpek' , this.idSpesifikasi ,Pdfbase64)
                }
            }

         
            
        },
        "pdf.file.files": function (newValue) {   
            let Pdfbase64 = []
            if(newValue.length != 0){
                for(var file of newValue){
                    Pdfbase64.push(file.file)
                }
            this.$emit('changeSESpek' , this.idSpesifikasi ,Pdfbase64)
            }
            if(newValue.length == 0){
                this.$emit('changeSESpek' , this.idSpesifikasi ,null)
            }
        },
    },   
  
}
</script>
